'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withPauseAndHelpLogic from '../higherOrderComponents/withPauseAndHelpLogic';
import { loadVidyardApi } from 'ui-addon-video-player/utils/loadPlayerApi';

function generateRandomString() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

var ONPLAY_TIMEOUT = 500;

var VidyardVideoPlayer = /*#__PURE__*/function (_Component) {
  _inherits(VidyardVideoPlayer, _Component);

  function VidyardVideoPlayer(props) {
    var _this;

    _classCallCheck(this, VidyardVideoPlayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VidyardVideoPlayer).call(this, props));
    _this.uniqueId = "ui-addon-video-player-container-" + generateRandomString();
    _this.state = {
      hasMarkedProgress: false,
      onPlayTimeout: undefined
    };
    _this.bindVideoEvents = _this.bindVideoEvents.bind(_assertThisInitialized(_this));
    _this.getVidyardPlayer = _this.getVidyardPlayer.bind(_assertThisInitialized(_this));
    _this.handleVideoPlay = _this.handleVideoPlay.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(VidyardVideoPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (window.vidyardEmbed) {
        this.initVideoPlayer(this.props.videoId);
      } else {
        loadVidyardApi(function () {
          _this2.initVideoPlayer(_this2.props.videoId);
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.videoId !== this.props.videoId && window.vidyardEmbed) {
        prevProps.cancelHelpTextTimeout();
        var oldPlayer = this.getVidyardPlayer(prevProps);

        if (oldPlayer) {
          // There isn't a method on the Vidyard API to replace the video in a player with another,
          // so for now we just have to tear down the player nad set up a new one.
          window.vidyardEmbed.api.destroyPlayer(oldPlayer);
          prevProps.onChangeVideo();
        }

        this.setState({
          hasMarkedProgress: false
        });
        this.updateVideoPlayer(this.props.videoId);
      } else if (prevProps.videoPlaySpeed !== this.props.videoPlaySpeed) {
        var player = this.getVidyardPlayer();

        if (player) {
          player.setPlaybackSpeed(this.props.videoPlaySpeed / 100);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var maybePlayer = this.getVidyardPlayer();

      if (maybePlayer) {
        window.vidyardEmbed.api.destroyPlayer(maybePlayer);
      }
    }
  }, {
    key: "onPlayerReady",
    value: function onPlayerReady(player) {
      var _this$props = this.props,
          cancelHelpTextTimeout = _this$props.cancelHelpTextTimeout,
          captionsOnByDefault = _this$props.captionsOnByDefault,
          onReady = _this$props.onReady;
      cancelHelpTextTimeout();
      this.bindVideoEvents(player);

      if (captionsOnByDefault) {
        player.enableCaption();
      }

      if (onReady) {
        onReady();
      }
    }
  }, {
    key: "initVideoPlayer",
    value: function initVideoPlayer(initialUuid) {
      var _this3 = this;

      window.vidyardEmbed.api.addReadyListener(function (_, player) {
        if (player.uuid === _this3.props.videoId) {
          _this3.onPlayerReady(player);
        }
      });
      this.updateVideoPlayer(initialUuid);
    }
  }, {
    key: "updateVideoPlayer",
    value: function updateVideoPlayer(uuid) {
      var _this$props2 = this.props,
          enableEmbed = _this$props2.enableEmbed,
          enableSharing = _this$props2.enableSharing,
          color = _this$props2.color;
      this.props.startHelpTextTimeout();
      window.vidyardEmbed.api.renderPlayer(Object.assign({
        color: color.indexOf('#') === 0 ? color.substr(1) : color,
        container: document.getElementById(this.uniqueId),
        embed_button: enableSharing ? 1 : 0,
        uuid: uuid,
        viral_sharing: enableEmbed ? 1 : 0
      }, this.getOptionsFromProps()));
    }
  }, {
    key: "getVidyardPlayer",
    value: function getVidyardPlayer() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var videoId = props.videoId;

      if (window.VidyardV4) {
        var players = window.VidyardV4.api.getPlayersByUUID(videoId);
        return players[0];
      }

      return undefined;
    }
  }, {
    key: "getOptionsFromProps",
    value: function getOptionsFromProps() {
      var _this$props3 = this.props,
          color = _this$props3.color,
          autoPlay = _this$props3.autoPlay,
          videoPlaySpeed = _this$props3.videoPlaySpeed,
          preload = _this$props3.preload;
      return {
        autoplay: autoPlay ? '1' : '0',
        play_button_color: color && color.replace('#', ''),
        speed: videoPlaySpeed / 100,
        preload: preload || 'metadata'
      };
    }
  }, {
    key: "handleVideoPlay",
    value: function handleVideoPlay() {
      var _this4 = this;

      // The first video play video play on an instance of a Vidyard player
      // causes the `onPlay` handler to be fired twice in very quick succession.
      // I'm going to debounce the onPlay here.
      if (!this.state.onPlayTimeout) {
        this.setState({
          onPlayTimeout: setTimeout(function () {
            _this4.props.onPlay();

            _this4.setState({
              onPlayTimeout: undefined
            });
          }, ONPLAY_TIMEOUT)
        });
      }
    }
  }, {
    key: "bindVideoEvents",
    value: function bindVideoEvents(player) {
      var _this5 = this;

      var _this$props4 = this.props,
          onPlay = _this$props4.onPlay,
          onFinish = _this$props4.onFinish,
          onPause = _this$props4.onPause,
          onUpdateProgress = _this$props4.onUpdateProgress;

      if (onPlay) {
        player.on('play', this.handleVideoPlay);
      }

      if (onPause) {
        player.on('pause', onPause);
      }

      if (onFinish) {
        player.on('playerComplete', onFinish);
      }

      if (onUpdateProgress) {
        player.on('timeupdate', function (seconds) {
          if (!_this5.state.hasMarkedProgress && seconds > 10) {
            _this5.setState({
              hasMarkedProgress: true
            });

            onUpdateProgress();
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {
        id: this.uniqueId
      });
    }
  }]);

  return VidyardVideoPlayer;
}(Component);

VidyardVideoPlayer.propTypes = {
  autoPlay: PropTypes.bool,
  cancelHelpTextTimeout: PropTypes.func.isRequired,
  captionsOnByDefault: PropTypes.bool,
  color: PropTypes.string,
  enableEmbed: PropTypes.bool,
  enableSharing: PropTypes.bool,
  preload: PropTypes.string,
  onFinish: PropTypes.func,
  onPause: PropTypes.func,
  onPlay: PropTypes.func,
  onReady: PropTypes.func,
  onChangeVideo: PropTypes.func,
  onUpdateProgress: PropTypes.func,
  startHelpTextTimeout: PropTypes.func.isRequired,
  videoId: PropTypes.string.isRequired,
  videoPlaySpeed: PropTypes.number
};
export default withPauseAndHelpLogic(VidyardVideoPlayer);